import React from 'react';
import { Create as AkCreate, type CreateProps } from '@atlaskit/atlassian-navigation';
import { SkeletonCreateButton } from '@atlaskit/atlassian-navigation/skeleton';

export const Create = (props: CreateProps) => {
	if (__SERVER__) {
		return <SkeletonCreateButton text={props.text} testId={props.testId} />;
	}

	return <AkCreate {...props} />;
};
